import { PRODUCT_IMAGES } from "../constants/action-types";

export const uploadProductImages = (results) => {
    const fileIds = results.map((fileUploadResult) => fileUploadResult.id);

    return {
        type: PRODUCT_IMAGES.UPLOAD.START,
        payload: { url: "/api/v3.0/vetl/product-images/upload", body: fileIds },
    };
};

export const startProductImageUploadJobPolling = (payload) => ({ type: PRODUCT_IMAGES.JOB.POLL.START, payload });

export const fetchProductImageUploadJob = (jobId: string, pipelineId: string) => ({
    type: PRODUCT_IMAGES.JOB.FETCH.START,
    payload: { url: "/api/v3.0/vetl/job", body: { jobId, pipelineId } },
});

export const resetUploadJob = () => ({ type: PRODUCT_IMAGES.JOB.RESET });
